import styled from 'styled-components';
import { Spacing4, Spacing8, Spacing12, Spacing16 } from 'autogen/design-tokens/tokens';
import type { ProductTabHighlightsModel } from 'autogen/swagger/all';
import Tag from 'components/generic/tag';
import format from 'helpers/translations';
import { breakpoint, sizes } from 'variables';
import CertificationHighlights from './components/CertificationHighlights';

const HighlightContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${Spacing12};
`;

const TeaserContent = styled.div`
    margin-bottom: ${Spacing16};
`;

const StyledTag = styled(Tag)`
    margin-right: ${Spacing4};
    margin-bottom: ${Spacing4};

    ${breakpoint.up(sizes.xxxl)} {
        margin-right: ${Spacing8};
        margin-bottom: ${Spacing8};
    }
`;

const StyledCertificationHighlights = styled(CertificationHighlights)`
    margin-bottom: ${Spacing16};
`;

export default function Highlights({ ...props }: ProductTabHighlightsModel): JSX.Element {
    const { highlights, teaserContent, certificationHighlights } = props;

    highlights.sort((a, b) => (a.sortOrder < b.sortOrder ? -1 : 1));

    return (
        <div>
            {!!highlights?.length && (
                <HighlightContainer>
                    {highlights.map((highlight) => {
                        const { text } = highlight;

                        return <StyledTag text={text} key={text} />;
                    })}
                </HighlightContainer>
            )}
            {!!certificationHighlights?.length && (
                <StyledCertificationHighlights highlights={certificationHighlights} />
            )}
            {teaserContent && <TeaserContent>{format(teaserContent)}</TeaserContent>}
        </div>
    );
}
